import Web3 from 'web3';

import { LOCAL_STORAGE_PREFIX } from 'const';
import { UsingDevKey } from 'utils/Dev';

// allows to specify human-readable words as value of ?dogem param
const customReferrals = {
  carlos: '0xB4Ab827cD769471E53DE31372e15a34D7e5B1A5B',
}

const referrerIdForLS = LOCAL_STORAGE_PREFIX + 'referrerAddress';


export function GenerateReferralURL(address) {
  if (!address) throw new SyntaxError('missing required argument: address');
  const siteName = window.location.hostname;
  //const siteName = 'dogebets.gg';
  const encodedAddress = window.btoa(address);
  const referralURL = siteName + '/?dogem=' + encodedAddress;
  return referralURL;
}


export function HandleReferralParams() {
  const queryParams = new URLSearchParams(window.location.search);
  const referrerRaw = queryParams.get('dogem');
  const referrerDecoded = window.atob(referrerRaw);

  //localStorage.removeItem('referrer');

  if (referrerRaw === null || referrerRaw === '')
    return;

  const referrerAddressIsValid = (referrerDecoded.length === 42
    && Web3.utils.checkAddressChecksum(referrerDecoded));
  if (referrerAddressIsValid) {
    if (UsingDevKey())
      alert('referrer detected: ' + referrerDecoded);
    //console.info('referrer detected: ' + referrerDecoded);
    SaveReferrerToLocalStorage(referrerDecoded);
  } else if (customReferrals[referrerRaw]) {
    if (UsingDevKey())
      alert('custom referrer detected: ' + `${referrerRaw}, address: ${customReferrals[referrerRaw]}`)
    SaveReferrerToLocalStorage(customReferrals[referrerRaw]);
    //console.info({ referrerName: referrerRaw, address: customReferrals[referrerRaw] });
  } else {
    if (UsingDevKey())
      alert(`mangled referrer value received ${referrerRaw}`)
    console.warn('mangled referrer address received:');
    console.warn({ raw: referrerRaw, decoded: referrerDecoded });
  }
}


export function SaveReferrerToLocalStorage(referrerAddress) {
  if (referrerAddress === undefined) throw new SyntaxError('missing required argument: referrerAddress');
  const referrerAddressIsValid = (referrerAddress.length === 42
    && Web3.utils.checkAddressChecksum(referrerAddress));

  if (referrerAddressIsValid) {
    localStorage.setItem(referrerIdForLS, referrerAddress);
  } else {
    const error = `referrerAddress '${referrerAddress}' doesn't seem to be a valid ethereum address`;
    if (UsingDevKey())
      alert(error);
    throw new TypeError(error);
  }
}

export function ClearReferrerFromLocalStorage() {
  localStorage.removeItem(referrerIdForLS);
}

export function GetReferrerFromLocalStorage() {
  const referrerAddress = localStorage.getItem(referrerIdForLS);
  if (UsingDevKey()) {
    console.info('Referrer from localStorage: ' + referrerAddress);
    alert('Referrer from localStorage: ' + referrerAddress);
  }
  return referrerAddress;
}